export default __webpack_public_path__ + "static/media/frg--gymnasium.17e49400.png";